import Model, { attr } from '@ember-data/model';
import Store from '@ember-data/store';
import dateUtils from 'donor-elf-web/lib/date-utils';
import PledgeModel from './pledge';

export default class JournalDecisionModel extends Model {
  @attr('string') declare journalContactId: string;
  @attr('string') declare journalGoalId: string;
  @attr('string') pledgeId?: string;
  @attr('date-only') declare decisionDate: Date;
  @attr('boolean') declare yesNo: boolean;
  @attr('number') amount?: number;
  @attr('date-only') firstGiftDate?: Date;
  @attr('boolean') pledgeIncreased?: boolean;
  @attr() prevPledgeInfo?: {
    id: number;
    amount: number;
    frequency: number;
    start_date: string;
    end_date: string;
  }; // see JournalDecision in ruby code

  _prevPledge: PledgeModel | undefined | null;
  getPrevPledge(store: Store): PledgeModel | undefined | null {
    if (this._prevPledge !== undefined) {
      return this._prevPledge;
    }
    let info = this.prevPledgeInfo;
    if (info == null) {
      return (this._prevPledge = null);
    }
    return (this._prevPledge = store.createRecord('pledge', {
      amount: info.amount,
      frequency: info.frequency,
      startDate: dateUtils.deserializeDateOnly(info.start_date),
      endDate: dateUtils.deserializeDateOnly(info.end_date),
    }));
  }
}
